import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function CaretIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 -1 12 8"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.2807 0.305288L5.98771 4.59829L1.69471 0.305288C1.50611 0.12313 1.25351 0.0223358 0.991311 0.0246142C0.729114 0.0268926 0.478301 0.132062 0.292893 0.31747C0.107485 0.502878 0.00231622 0.75369 3.78026e-05 1.01589C-0.00224062 1.27808 0.0985538 1.53069 0.280712 1.71929L5.28071 6.71929C5.46824 6.90676 5.72255 7.01207 5.98771 7.01207C6.25288 7.01207 6.50718 6.90676 6.69471 6.71929L11.6947 1.71929C11.7902 1.62704 11.8664 1.5167 11.9188 1.39469C11.9712 1.27269 11.9988 1.14147 12 1.00869C12.0011 0.87591 11.9758 0.744231 11.9255 0.621334C11.8753 0.498438 11.801 0.386786 11.7071 0.292893C11.6132 0.199001 11.5016 0.124747 11.3787 0.0744666C11.2558 0.0241857 11.1241 -0.00111606 10.9913 3.77567e-05C10.8585 0.00119157 10.7273 0.0287779 10.6053 0.0811869C10.4833 0.133596 10.373 0.209778 10.2807 0.305288Z" />
      </svg>
    </Icon>
  );
}
